module.exports = __webpack_public_path__ + "img/motherboard-232515_1920.1310a832.jpg";